import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
@Injectable({
  providedIn: 'root',
})
export class ErrorHandlingService {
  constructor(private toastr: ToastrService) {}

  public handleError(error: HttpErrorResponse) {
    let errorMessage: string;

    if (this.shouldHandleErrorInComponent(error)) return;

    errorMessage = this.getErrorMessage(error);
    this.toastr.error(errorMessage, 'Error');
  }

  private shouldHandleErrorInComponent(error: HttpErrorResponse): boolean {
    return (
      error.status === HttpStatusCode.NotFound ||
      error.status === HttpStatusCode.Conflict
    );
  }

  public handleErrorInComponent(
    error: HttpErrorResponse,
    errorMessage: string
  ): void {
    switch (error.status) {
      case HttpStatusCode.Conflict:
        this.toastr.error(errorMessage);
        break;
      case HttpStatusCode.NotFound:
        this.toastr.error(errorMessage);
        break;
    }
  }

  private getErrorMessage(error: HttpErrorResponse): string {
    return error.error instanceof ErrorEvent
      ? error.error.message
      : error.error.errorMessage;
  }
}
